import React, {Component} from "react"
import PropTypes from "prop-types"

import {FullEmojiPicker} from "@irati/ui/src/Reactions"
import AddReactionMutation from "@irati/recognition/apollo/mutation/AddReaction"

import FeedWrapper from "./FeedWrapper"
import PopUpWrapper from "./PopUpWrapper"

class AddReaction extends Component {
  static propTypes = {
    comment: PropTypes.shape({
      uuid: PropTypes.string.isRequired
    }),
    feedItem: PropTypes.bool,
    item: PropTypes.shape({
      comments: PropTypes.object.isRequired
    }),
    togglePickerModal: PropTypes.func.isRequired
  }

  static defaultProps = {
    comment: null,
    feedItem: false,
    item: null
  }

  render() {
    const {comment, feedItem, item, togglePickerModal} = this.props

    const Comp = feedItem ? FeedWrapper : PopUpWrapper

    return (
      <AddReactionMutation comment={comment} item={item} onCompleted={() => console.log("complete!")} onError={() => console.log("error")}>
        {(onClick) => (
          <Comp>
            <FullEmojiPicker
              onClick={(emoji, e) => {
                onClick(emoji)
                togglePickerModal()
                e.stopPropagation()
              }}
              togglePickerModal={togglePickerModal}
            />
          </Comp>
        )}
      </AddReactionMutation>
    )
  }
}

export default AddReaction
